import { $getComFamilies } from "../../requests"
import { result as convertTree } from "../../../utils/tree/index"

import { ActionTypes } from ".."
import { loadTree } from "./act_tree"
import {
  DropitState,
  getTranslationsByScope,
  getUserRole,
} from "../../reducers"
import { responseType, transform } from "../../../utils/http-res-handler"

export const fetchAllComFamilies = () => (
  dispatch: (callback: object) => void,
  getState: () => DropitState
) => {
  const state = getState()
  const role = getUserRole(state)

  if (state.miscellaneous.comTree.isLoading) {
    return
  }

  dispatch({
    type: ActionTypes.START_FETCHING_TECH_FAMILIES,
    treeName: "comTree",
  })

  return $getComFamilies(role)
    .then((res) =>
      transform(
        res,
        getTranslationsByScope(getState(), "toastrLabels"),
        responseType.json
      )
    )
    .then((response: any) => {
      const data = convertTree(response)
      dispatch(loadTree({ treeName: "comTree", rawData: response, data }))
    })
    .catch((err: any) =>
      dispatch({
        errorMessage: err.message,
        type: ActionTypes.FETCH_TECH_FAMILIES_FAIL,
        treeName: "comTree",
      })
    )
}
